import { RefObject, useEffect, useState } from 'react';

export function useIsScrolledPast(
  ref: RefObject<HTMLElement>,
  enabled: boolean = true
) {
  const [isScrolledPast, setIsScrolledPast] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!enabled || !element) {
      setIsScrolledPast(false);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIsScrolledPast(
        !entry.isIntersecting && entry.boundingClientRect.top < 0
      );
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [ref, enabled]);

  return isScrolledPast;
}
